// DOM Ready functions using custom async function so it only funs when jQuery has been fully loaded
async.push(["ready", function() {
    // Favourites
    initFavourites();
}]);

// Listing Favourites
window.initFavourites = function initFavourites() {

    $('#wrapper').on('click', '.addtofavs', function(e) {
        e.preventDefault();
        var loggedin = $('body').hasClass('loggedin');

        // allow add to favourite
        if (loggedin) {

            var btn = $(this);
            var listingid = btn.data('listingid');
            var saction = btn.data('saction');

            if (btn.hasClass('saved')) {
                saction = 'removeFromFavourites';
            }
            if (typeof saction === 'undefined') {
                saction = 'addToFavourites';
            }

            // ajax post data, then swap icon
            $.ajax({
                url: '/api/vehicles/data/' + saction,
                method: 'post',
                data: {
                    // saction: saction,
                    listingid: listingid
                },
                dataType: "json"
            }).done(function(response) {

                if (response.success) {
                    // change icon and text
                    btn.find('.add').html(response.html);

                    // update new saction
                    btn.data('saction', response.saction);

                    // update btn class
                    if (response.status == 'saved') {
                        btn.addClass('saved');
                        // btn.attr('title', 'Remove from favourites');
                        // btn.attr('data-original-title', 'Remove&nbsp;from&nbsp;favourites').tooltip('hide');
                    } else {
                        btn.removeClass('saved');
                        // btn.attr('title', 'Add to favourites');
                        // btn.attr('data-original-title', 'Add&nbsp;to&nbsp;favourites').tooltip('hide');
                    }
                    // showNotification(response, 'success');
                } else {
                    alert('Error');
                    // // show growl error notification
                    // showNotification(response, 'danger');
                }



                // change icon
                // if(icon.hasClass('fa-plus')){
                //     icon.removeClass('fa-plus').addClass('fa-minus');
                // }else{
                //     icon.removeClass('fa-minus').addClass('fa-plus');
                // }

                // if saction == remove and has class quotelist then remove table row
                if (saction == 'removeFromFavourites' && btn.hasClass('favouritelist')) {
                    btn.closest('tr').slideUp('slow'); //.remove();
                }

            });

        }
        // if not logged in open login modal
        else {
            // trigger login modal
            $('#signin-modal').modal('show');
        }
    });

}